module.exports = __webpack_public_path__ + "static/media/RoadMap_elImage_754884.5d55724a.png";